import React from "react";
import "./App.scss";
import Register from "./pages/register/Register";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CustomerRegister from "./pages/customerRegister/CustomerRegister";
import CustomerVerification from "./pages/customerVerifiation/CustomerVerification";
import AccountVerified from "./pages/accountVerified/AccountVerfied";

const App: React.FC = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route path={"/customer/register"} element={<Register />} />
          <Route path={"/"} element={<CustomerRegister />} />
          <Route
            path={"/customer/verification"}
            element={<CustomerVerification />}
          />
          <Route path={"/customer/verified"} element={<AccountVerified />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
